import { useSelector } from 'react-redux';

import { mainReviewsSelector } from '@/domains/productDiscovery/ArticleReviews/MainReviews.ducks';
import { orderedByRelevanceAndDate } from '@/domains/productDiscovery/ArticleReviews/translations';

export const useMainReviews = () => {
  const { reviews, total, hasMoreReviews } = useSelector(mainReviewsSelector);

  const subtitle = orderedByRelevanceAndDate;

  return { reviews, total, hasMoreReviews, subtitle };
};
